import axios from "axios";
import { toast } from "react-toastify";
export const GetAllLoanPopulate = (data) => {
  return {
    type: "get_allLoanpopulate",
    payload: data,
    loader: false,
  };
};
export function getallLoanPopulate() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Loans/Populate`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllLoanPopulate(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
export const GetAllLoanTable = (data) => {
  return {
    type: "get_allLoantable",
    payload: data,
    loader: false,
  };
};
export function getallLoanTable() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Loans/GetAll`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllLoanTable(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
export const GetAllAdvanceTable = (data) => {
  return {
    type: "get_alladvancetable",
    payload: data,
    loader: false,
  };
};
export function getallAdvanceTable() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Advances/GetAll`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllAdvanceTable(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
